import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchReport } from './actions';
import MIMES from './../../../../data/constants/mimes';
import './styles.scss';
import {getStaffId} from "../../../BidSession/helpers";
import { useLanguage } from '../../../../context/LanguageContext';

class ReportLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      content: null,
      contentType: null,
    };

    this.isIpad = navigator.userAgent.match(/iPad/i);
  }

  componentDidMount() {
    const staffId = getStaffId();
    const uniqueIdentifier = this.props.match.params.uniqueIdentifier;

    fetchReport(uniqueIdentifier, staffId)
    .then((response) => {
      const out = new Blob([response.data], { type: response.data.type });

      /* On Internet Explorer, the only working approach is download a file */
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        const fileExtension = this.getFileExtension(response.data.type);
        const reportName = `${uniqueIdentifier}${fileExtension}`;

        window.navigator.msSaveOrOpenBlob(out, reportName);
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          /*
          iPad cannot load a Data URL containing a PDF file inside iframe,
          so in this case we replace the browser location to the complete Data URL
          */
          if (this.isIpad && response.data.type === 'application/pdf') {
            window.location.href = reader.result;
          } else {
            this.setState({ content: reader.result, contentType: response.data.type });
          }
        };
        reader.readAsDataURL(out);
      }
    })
    .catch((error) => {
      this.setState({ error });
    });
  }

  getFileExtension = (contentType) => {
    if (MIMES[contentType] !== undefined) {
      return `.${MIMES[contentType].extension}`;
    }
    return '';
  }

  render() {
    return (
      <div>
        {
        this.state.error ?
          <h3>{REPORTS.FAILED_TO_LOAD} {this.props.match.params.uniqueIdentifier}</h3>
        :
          <iframe
            src={this.state.content}
            className="report-iframe"
            allowFullScreen
            type={this.state.contentType}
          />
        }
      </div>
    );
  }
}

ReportLoader.propTypes = {
  params: PropTypes.object,
};

ReportLoader.defaultProps = {
  params: {},
};

function ReportLoaderWrapper(props) {
  const { labels } = useLanguage();
  return <ReportLoader {...props} labels={labels} />;
}

export default ReportLoaderWrapper;
